module.exports = __webpack_public_path__ + "img/Koala.022310bb.jpg";